import { ReactNode } from 'react'
import {
  StyledSidebar,
  StyledDetailsCard,
  StyledSectionTitle,
  StyledDetailItem,
  StyledDetailLabel,
  StyledDetailValue,
} from './details-page-styles'

type DetailRow = {
  label: string
  value?: ReactNode
}

type DetailsSidebarProps = {
  title?: string
  rows: DetailRow[]
}

const DetailsSidebar = ({ title = 'Details', rows }: DetailsSidebarProps) => {
  const visibleRows = rows.filter(
    (row) => row.value !== undefined && row.value !== null && row.value !== ''
  )

  if (visibleRows.length === 0) {
    return null
  }

  return (
    <StyledSidebar>
      <StyledDetailsCard>
        <StyledSectionTitle>{title}</StyledSectionTitle>
        {visibleRows.map((row) => (
          <StyledDetailItem key={row.label}>
            <StyledDetailLabel>{row.label}</StyledDetailLabel>
            {/* div, not <p>: values can be Typography elements (e.g. collection link) */}
            <StyledDetailValue component='div'>{row.value}</StyledDetailValue>
          </StyledDetailItem>
        ))}
      </StyledDetailsCard>
    </StyledSidebar>
  )
}

export default DetailsSidebar
